import script from "./Mascot.vue?vue&type=script&setup=true&lang=js"
export * from "./Mascot.vue?vue&type=script&setup=true&lang=js"

import "./Mascot.vue?vue&type=style&index=0&id=6ca3d18d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ca3d18d"]])

export default __exports__